import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StartedAtInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('sand.shaleapps.com/api')) {
      request = request.clone({
        setHeaders: {
          'x-started-at': `${Date.now()}`,
        },
      });
    }
    return next.handle(request);
  }
}
